import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Box,
  Container,
  Typography,
  Paper,
  Stack,
  Chip,
  Button,
  Skeleton,
  Divider,
  useTheme,
  alpha,
  Tabs,
  Tab,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Snackbar,
  Alert
} from '@mui/material';
import {
  Verified as BlueMarkIcon,
  EmojiEvents as TrophyIcon,
  Diamond as DiamondIcon,
  WorkspacePremium as PremiumIcon,
  Payment as PaymentIcon,
  ContentCopy as CopyIcon,
  CheckCircle as CheckIcon,
  School as SchoolIcon,
  ArrowForward as ArrowIcon,
  PhoneAndroid as PhoneIcon,
  ViewList as AllIcon,
  Chat as ChatIcon,
  Facebook as FacebookIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';
import { vipPlanAPI } from '../services/api';
import PaymentModal from '../components/PaymentModal';

// Mock Data for Development/Fallback
const MOCK_DATA = {
  "success": true,
  "data": {
    "languages": [
      {
        "id": "english",
        "name": "Easy English Language",
        "icon": "🇬🇧",
        "courses": [
          {"id": 11, "name": "Basic Course", "price": 10000, "priceLabel": "10,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 13, "name": "Elementary Course", "price": 10000, "priceLabel": "10,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 18, "name": "Translation Course", "price": 10000, "priceLabel": "10,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 26, "name": "Essential Speaking (On going)", "price": 15000, "priceLabel": "15,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 23, "name": "Listening Course ", "price": 10000, "priceLabel": "10,000 kyats", "blueMark": true, "remark": "", "isFree": false}
        ],
        "bundlePlans": [
          {
            "id": 4,
            "name": "Diamond Plan",
            "price": 30000,
            "priceLabel": "30,000 kyats",
            "blueMark": true,
            "remark": "Application မှ သင်ခန်းစာများ အားလုံးကို Life Time လေ့လာနိုင်မည်ဖြစ်ပါသည်။",
            "tier": "diamond",
            "color": "#b9f2ff",
            "savings": "",
            "courses": [11, 13, 18, 23, 26]
          }
        ]
      },
      {
        "id": "korea",
        "name": "Easy Korean Language",
        "icon": "🇰🇷",
        "courses": [
          {"id": 30, "name": "Level 5", "price": 35000, "priceLabel": "35,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 1, "name": "Basic Course", "price": 10000, "priceLabel": "10,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 2, "name": "Level One Course", "price": 15000, "priceLabel": "15,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 3, "name": "Level Two Course", "price": 15000, "priceLabel": "15,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 4, "name": "Level 3-1", "price": 20000, "priceLabel": "20,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 7, "name": "Level 3-2", "price": 20000, "priceLabel": "20,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 25, "name": "Level 4-1", "price": 20000, "priceLabel": "20,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 27, "name": "Level 4-2", "price": 20000, "priceLabel": "20,000 kyats", "blueMark": true, "remark": "", "isFree": false},
          {"id": 15, "name": "Vocabulary Course", "price": 0, "priceLabel": "0 kyats", "blueMark": true, "remark": "", "isFree": true},
          {"id": 28, "name": "Topik I", "price": 25000, "priceLabel": "25,000 kyats", "blueMark": true, "remark": "", "isFree": false}
        ],
        "bundlePlans": [
          {
            "id": 1,
            "name": "Silver Plan",
            "price": 30000,
            "priceLabel": "30,000 kyats",
            "blueMark": true,
            "remark": "Basic to Level 3-2 Course များအပြင် Additional Lesson အားလုံးလေ့လာနိုင်ပါသည်။ Life Time Access ရရှိပါသည်။",
            "tier": "silver",
            "color": "#C0C0C0",
            "savings": "",
            "courses": [1, 2, 3, 4, 7, 15]
          },
          {
            "id": 2,
            "name": "Gold plan",
            "price": 40000,
            "priceLabel": "40,000 kyats",
            "blueMark": true,
            "remark": "Basic to Level 4-2 Course များအပြင် Additional Lesson အားလုံးလေ့လာနိုင်ပါသည်။ Life Time Access ရရှိပါသည်။",
            "tier": "gold",
            "color": "#FFD700",
            "savings": "",
            "courses": [1, 2, 3, 4, 7, 15, 25, 27]
          },
          {
            "id": 3,
            "name": "Diamond Plan",
            "price": 50000,
            "priceLabel": "50,000 kyats",
            "blueMark": true,
            "remark": "Application မှ သင်ခန်းစာများ အားလုံးကို Life Time လေ့လာနိုင်မည်ဖြစ်ပါသည်။",
            "tier": "diamond",
            "color": "#b9f2ff",
            "savings": "",
            "courses": [1, 2, 3, 4, 7, 15, 25, 27, 28, 30]
          }
        ]
      },
      {
        "id": "japanese",
        "name": "Easy Japanese Language",
        "icon": "🇯🇵",
        "courses": [],
        "bundlePlans": []
      }
    ],
    "paymentMethods": [
      {"name": "Kpay", "accountName": "U Kaung Htet San", "accountNumber": "09250109968", "logo": "https://www.calamuseducation.com/uploads/payment/kpay.png"},
      {"name": "Wave Pay", "accountName": "U Kaung Htet San", "accountNumber": "09250109968", "logo": "https://www.calamuseducation.com/uploads/payment/wave.png"},
      {"name": "KBZ Banking", "accountName": "U Kaung Htet San", "accountNumber": "05730109250109901", "logo": "https://www.calamuseducation.com/uploads/payment/kbz.png"},
      {"name": "AYA Banking", "accountName": "U Kaung Htet San", "accountNumber": "20021272765", "logo": "https://www.calamuseducation.com/uploads/payment/aya.png"},
      {"name": "CB Banking", "accountName": "U Kaung Htet San", "accountNumber": "2243600500001726", "logo": "https://www.calamuseducation.com/uploads/payment/cb.png"}
    ],
    "contact": {
      "phone": ["09 250 10 99 68", "09 40 30 88 566"],
      "facebook": "https://www.facebook.com/calamuseducation",
      "viber": "viber://chat?number=959250109968"
    }
  }
};

// Tier icon & color
const getTierConfig = (theme, tier, customColor) => {
  const isLight = theme.palette.mode === 'light';
  
  const defaults = {
    diamond: { 
      icon: <DiamondIcon />, 
      color: isLight ? '#00838f' : '#4dd0e1', 
      bg: isLight ? 'linear-gradient(135deg, #e0f7fa 0%, #b2ebf2 100%)' : 'linear-gradient(135deg, #006064 0%, #00838f 100%)',
    },
    gold: { 
      icon: <TrophyIcon />, 
      color: isLight ? '#f57f17' : '#ffd54f', 
      bg: isLight ? 'linear-gradient(135deg, #fff8e1 0%, #ffe082 100%)' : 'linear-gradient(135deg, #f57f17 0%, #ffb300 100%)',
    },
    silver: { 
      icon: <PremiumIcon />, 
      color: isLight ? '#616161' : '#e0e0e0', 
      bg: isLight ? 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)' : 'linear-gradient(135deg, #424242 0%, #616161 100%)',
    },
  };

  const config = defaults[tier] || defaults.silver;

  if (customColor) {
    // If a custom color is provided from API, use it to generate a matching theme
    return {
      ...config,
      color: isLight ?  alpha(customColor, 0.9) : customColor,
      bg: isLight 
        ? `linear-gradient(135deg, ${alpha(customColor, 0.1)} 0%, ${alpha(customColor, 0.3)} 100%)`
        : `linear-gradient(135deg, ${alpha(customColor, 0.2)} 0%, ${alpha(customColor, 0.4)} 100%)`
    };
  }

  return config;
};

// Bundle Plan Card
const BundlePlanCard = ({ plan, isPopular, allCourses, onPurchase, isPurchased, onLearn }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const tierConfig = getTierConfig(theme, plan.tier, plan.color);
  const [expanded, setExpanded] = useState(false);

  // Map course IDs to names
  const includedCourses = useMemo(() => {
    if (!plan.courses || !allCourses) return [];
    return plan.courses.map(id => allCourses.find(c => c.id === id)).filter(Boolean);
  }, [plan.courses, allCourses]);

  const handleLearn = () => {
    if (typeof onLearn === 'function') {
      onLearn(plan);
      return;
    }
    navigate('/my-learning');
  };

  return (
    <Paper
      elevation={0}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: theme.palette.background.paper,
        boxShadow: isPopular
          ? `0 4px 16px ${alpha(tierConfig.color, 0.2)}`
          : `0 1px 4px ${alpha(theme.palette.common.black, 0.05)}`,
        border: '1px solid',
        borderColor: isPopular ? tierConfig.color : theme.palette.divider,
        borderRadius: '16px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: `0 8px 24px ${alpha(tierConfig.color, 0.2)}`,
        },
      }}
    >
      {isPopular && (
        <Box 
          sx={{ 
            position: 'absolute',
            top: 15,
            right: -32,
            transform: 'rotate(45deg)',
            bgcolor: tierConfig.color, 
            color: theme.palette.getContrastText(tierConfig.color), 
            width: 120,
            textAlign: 'center', 
            py: 0.25, 
            fontSize: '0.6rem', 
            fontWeight: 800, 
            letterSpacing: 0.5,
            zIndex: 2,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          POPULAR
        </Box>
      )}

      <Box sx={{ background: tierConfig.bg, p: 2, textAlign: 'center', position: 'relative' }}>
        <Avatar 
          sx={{ 
            width: 48, 
            height: 48, 
            mx: 'auto', 
            mb: 1, 
            bgcolor: theme.palette.background.paper, 
            color: tierConfig.color,
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
          }}
        >
          {React.cloneElement(tierConfig.icon, { fontSize: 'medium' })}
        </Avatar>
        <Typography variant="subtitle1" fontWeight={800} sx={{ color: 'text.primary', mb: 0.5 }}>
          {plan.name}
        </Typography>
        <Typography variant="h5" fontWeight={900} color={tierConfig.color}>
          {plan.priceLabel}
        </Typography>
      </Box>

      <Box sx={{ p: 2, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        
        <Typography variant="caption" color="text.secondary" fontWeight={500} sx={{ mb: 2, textAlign: 'center', minHeight: 32, lineHeight: 1.4 }}>
          {plan.remark}
        </Typography>

        <Divider sx={{ mb: 1.5 }} />

        <Stack spacing={1} sx={{ mb: 2, flexGrow: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <CheckIcon sx={{ fontSize: 16, color: 'success.main' }} />
            <Typography variant="body2" fontWeight={600} fontSize="0.85rem">Lifetime Access</Typography>
          </Stack>
          
          {plan.blueMark && (
            <Stack direction="row" alignItems="center" spacing={1}>
              <BlueMarkIcon sx={{ fontSize: 16, color: 'info.main' }} />
              <Typography variant="body2" fontWeight={600} fontSize="0.85rem">Verified Certificate</Typography>
            </Stack>
          )}

          {/* Collapsible Course List */}
          {includedCourses.length > 0 && (
            <Box>
              <Button
                onClick={() => setExpanded(!expanded)}
                endIcon={expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                color="inherit"
                size="small"
                sx={{ 
                  textTransform: 'none', 
                  justifyContent: 'flex-start', 
                  px: 0, 
                  width: '100%',
                  color: 'text.secondary',
                  '&:hover': { bgcolor: 'transparent', textDecoration: 'underline', color: 'text.primary' }
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <SchoolIcon sx={{ fontSize: 16 }} />
                  <Typography variant="body2" fontWeight={600} fontSize="0.85rem">
                    {includedCourses.length} Courses Included
                  </Typography>
                </Stack>
              </Button>
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                <List 
                  dense 
                  disablePadding 
                  sx={{ 
                    mt: 1, 
                    bgcolor: alpha(tierConfig.color, 0.05), 
                    borderRadius: 2,
                    border: `1px solid ${alpha(tierConfig.color, 0.15)}`,
                    overflow: 'hidden'
                  }}
                >
                  {includedCourses.map((course) => (
                    <ListItem key={course.id} sx={{ py: 0.75, px: 1.5, borderBottom: `1px solid ${alpha(tierConfig.color, 0.05)}`, '&:last-child': { borderBottom: 'none' } }}>
                      <ListItemIcon sx={{ minWidth: 24 }}>
                        <CheckIcon fontSize="inherit" sx={{ fontSize: 14, color: tierConfig.color }} />
                      </ListItemIcon>
                      <ListItemText 
                        primary={course.name} 
                        primaryTypographyProps={{ variant: 'caption', fontWeight: 600, color: 'text.primary', fontSize: '0.8rem' }} 
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </Box>
          )}
        </Stack>

        <Button
          variant="contained"
          fullWidth
          size="medium"
          endIcon={<ArrowIcon fontSize="small" />}
          onClick={isPurchased ? handleLearn : () => onPurchase(plan)}
          sx={{ 
            py: 1,
            borderRadius: '12px',
            fontWeight: 700,
            fontSize: '0.9rem',
            bgcolor: tierConfig.color,
            color: theme.palette.getContrastText(tierConfig.color),
            boxShadow: `0 4px 12px ${alpha(tierConfig.color, 0.3)}`,
            '&:hover': {
              bgcolor: alpha(tierConfig.color, 0.9),
              boxShadow: `0 8px 20px ${alpha(tierConfig.color, 0.4)}`,
            }
          }}
        >
          {isPurchased ? 'Learn' : 'Paid'}
        </Button>
      </Box>
    </Paper>
  );
};

// Course Row
const CourseRow = ({ course, isLast, onPurchase, isPurchased }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleLearn = () => navigate(`/course/${course.id}`);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 1,
        px: 2,
        borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
        transition: 'background-color 0.2s',
        '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.04) },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
        <Avatar 
          variant="rounded" 
          sx={{ 
            width: 32, 
            height: 32, 
            bgcolor: alpha(course.isFree ? theme.palette.success.main : theme.palette.primary.main, 0.1),
            color: course.isFree ? 'success.main' : 'primary.main'
          }}
        >
          <SchoolIcon sx={{ fontSize: 18 }} />
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2" fontWeight={600} noWrap sx={{ fontSize: '0.85rem' }}>
              {course.name}
            </Typography>
            {course.blueMark && <BlueMarkIcon sx={{ fontSize: 14, color: 'info.main' }} />}
          </Stack>
          {course.remark && (
            <Typography variant="caption" color="text.secondary" display="block" noWrap sx={{ fontSize: '0.7rem' }}>
              {course.remark}
            </Typography>
          )}
        </Box>
      </Stack>
      
      <Stack direction="row" alignItems="center" spacing={1}>
        <Chip
          label={course.isFree ? 'Free' : course.priceLabel}
          size="small"
          color={course.isFree ? 'success' : 'default'}
          variant={course.isFree ? 'filled' : 'outlined'}
          sx={{ fontWeight: 700, height: 24, fontSize: '0.7rem' }}
        />
        {!course.isFree && (
          <Button
            variant="contained"
            size="small"
            disableElevation
            onClick={isPurchased ? handleLearn : () => onPurchase(course)}
            sx={{ 
              minWidth: 0,
              px: 2,
              height: 28,
              fontSize: '0.75rem',
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: '8px'
            }}
          >
            {isPurchased ? 'Learn' : 'Paid'}
          </Button>
        )}
      </Stack>
    </Box>
  );
};

// Payment Method Card
const PaymentMethodCard = ({ method, onCopy, copied }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        '&:hover': { 
          borderColor: 'primary.main', 
          boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.1)}`,
          transform: 'translateY(-2px)'
        },
      }}
      onClick={() => onCopy(method.accountNumber)}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Avatar 
          src={method.logo}
          variant="rounded"
          sx={{ width: 36, height: 36, bgcolor: 'transparent', objectFit: 'contain' }}
        >
          {!method.logo && <PaymentIcon fontSize="small" />}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle2" fontWeight={700} fontSize="0.85rem" sx={{ lineHeight: 1.2 }}>
            {method.name}
          </Typography>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="caption" color="text.secondary" fontWeight={500}>
              {method.accountNumber}
            </Typography>
            {copied === method.accountNumber && <CheckIcon color="success" sx={{ fontSize: 14 }} />}
          </Stack>
          <Typography variant="caption" color="text.disabled" display="block" sx={{ lineHeight: 1 }}>
            {method.accountName}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

// Language Section (used in "All" view and single-language view)
const LanguageSection = ({ language, showLabel, onPurchase, purchasedCoursesByMajor }) => {
  const theme = useTheme();
  const purchasedSet = useMemo(() => {
    const ids = purchasedCoursesByMajor?.[language.id] || [];
    return new Set(ids.map((id) => Number(id)));
  }, [purchasedCoursesByMajor, language.id]);

  const handlePurchase = (planOrCourse) => {
    const isBundle = typeof planOrCourse?.tier === 'string';
    const resolvedCourses = isBundle ? planOrCourse.courses : [planOrCourse.id];
    onPurchase({ ...planOrCourse, major: language.id, courses: resolvedCourses });
  };

  return (
    <Box>
      {showLabel && (
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
          <Typography fontSize="1.5rem">{language.icon}</Typography>
          <Typography variant="h6" fontWeight={800}>{language.name}</Typography>
        </Stack>
      )}

      {/* Bundle Plans */}
      {language.bundlePlans?.length > 0 && (
        <Box sx={{ mb: 3 }}>
          {!showLabel && (
            <Typography variant="subtitle1" fontWeight={800} sx={{ mb: 2 }}>
              Recommended Plans
            </Typography>
          )}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                md: language.bundlePlans.length <= 3
                  ? `repeat(${language.bundlePlans.length}, 1fr)`
                  : 'repeat(3, 1fr)',
              },
              gap: 2,
            }}
          >
            {language.bundlePlans.map((plan, i) => (
              <BundlePlanCard
                key={i}
                plan={plan}
                isPopular={plan.tier === 'diamond'}
                allCourses={language.courses}
                isPurchased={Array.isArray(plan.courses) && plan.courses.length > 0 && plan.courses.every((id) => purchasedSet.has(Number(id)))}
                onPurchase={handlePurchase}
              />
            ))}
          </Box>
        </Box>
      )}

      {/* Individual Courses */}
      <Box sx={{ mb: showLabel ? 3 : 4 }}>
        {!showLabel && (
          <Typography variant="subtitle1" fontWeight={800} sx={{ mb: 2 }}>
            All Courses
          </Typography>
        )}
        <Paper
          elevation={0}
          sx={{ 
            overflow: 'hidden', 
            border: '1px solid', 
            borderColor: 'divider',
            borderRadius: 3,
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
          }}
        >
          {language.courses.map((course, i) => (
            <CourseRow
              key={i}
              course={course}
              isLast={i === language.courses.length - 1}
              isPurchased={purchasedSet.has(Number(course.id))}
              onPurchase={handlePurchase}
            />
          ))}
        </Paper>
      </Box>
    </Box>
  );
};

// Skeleton
const VipPlanSkeleton = () => (
  <Container maxWidth="lg" sx={{ py: 3, px: { xs: 2, sm: 3, md: 4 } }}>
    <Skeleton variant="text" width={200} height={36} sx={{ mb: 0.5 }} />
    <Skeleton variant="text" width={320} height={20} sx={{ mb: 3 }} />
    <Skeleton variant="rounded" height={48} sx={{ mb: 4 }} />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 4 }}>
      {[1, 2, 3].map((i) => (
        <Skeleton key={i} variant="rounded" height={320} sx={{ flex: 1 }} />
      ))}
    </Stack>
    <Skeleton variant="rounded" height={250} />
  </Container>
);

const VipPlan = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0); // 0 = All, 1 = English, 2 = Korean
  const [copied, setCopied] = useState(null);
  
  // Payment Modal State
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Attempt to fetch from API
        const response = await vipPlanAPI.get();
        if (response.data && response.data.languages) {
          setData(response.data);
        } else {
          // Fallback to mock data if structure doesn't match or empty
          console.warn('API response empty or invalid structure, using mock data');
          setData(MOCK_DATA.data);
        }
      } catch (err) {
        console.error('Failed to load VIP plan data, using mock data:', err);
        // Fallback to mock data on error
        setData(MOCK_DATA.data);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(text);
      setTimeout(() => setCopied(null), 2000);
    });
  };

  const handlePurchase = (planOrCourse) => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    setSelectedPlan(planOrCourse);
    setPaymentModalOpen(true);
  };

  const handlePaymentSuccess = () => {
    setSnackbar({
      open: true,
      message: 'Payment submitted successfully! We will review it shortly.',
      severity: 'success'
    });
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Build tab list: All + each language
  const tabs = useMemo(() => {
    if (!data) return [];
    return [
      { id: 'all', label: 'All', icon: '📋' },
      ...data.languages.map((lang) => ({ id: lang.id, label: lang.name, icon: lang.icon })),
    ];
  }, [data]);

  if (loading) return <VipPlanSkeleton />;

  if (!data) {
    return (
      <Box sx={{ textAlign: 'center', py: 4, px: { xs: 2, sm: 3 } }}>
        <Typography variant="subtitle1" color="error">Failed to load plan data</Typography>
        <Button variant="contained" size="small" sx={{ mt: 2 }} onClick={() => window.location.reload()}>Try Again</Button>
      </Box>
    );
  }

  const isAll = activeTab === 0;
  const activeLanguage = !isAll ? data.languages[activeTab - 1] : null;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 2, sm: 3 } }}>

        {/* Page Header - Simple & Clean */}
        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <Chip 
            label="VIP Membership" 
            color="primary" 
            size="small" 
            sx={{ mb: 1, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, height: 24, fontSize: '0.7rem' }} 
          />
          <Typography variant="h4" fontWeight={900} sx={{ letterSpacing: '-0.5px', mb: 1, fontSize: { xs: '1.5rem', md: '2rem' } }}>
            Choose Your Plan
          </Typography>
          <Typography variant="body2" color="text.secondary" fontWeight={400} sx={{ maxWidth: 500, mx: 'auto', lineHeight: 1.5 }}>
            Unlock your potential with our comprehensive language courses.
          </Typography>
        </Box>

        {/* Tab Filter */}
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
          <Tabs
            value={activeTab}
            onChange={(_, v) => setActiveTab(v)}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              bgcolor: 'background.paper',
              borderRadius: '50px',
              p: 0.5,
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              border: '1px solid',
              borderColor: 'divider',
              minHeight: 36,
              '& .MuiTabs-indicator': {
                display: 'none',
              },
              '& .MuiTab-root': {
                minHeight: 36,
                py: 0.5,
                px: 2,
                borderRadius: '40px',
                fontWeight: 700,
                fontSize: '0.8rem',
                textTransform: 'none',
                color: 'text.secondary',
                transition: 'all 0.2s',
                mr: 0.5,
                '&:last-child': { mr: 0 },
                '&.Mui-selected': {
                  bgcolor: 'primary.main',
                  color: 'primary.contrastText',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                },
                '&:hover:not(.Mui-selected)': {
                  bgcolor: alpha(theme.palette.primary.main, 0.08),
                }
              },
            }}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.id}
                label={
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <Typography component="span" fontSize="1rem">{tab.icon}</Typography>
                    <span>{tab.label}</span>
                  </Stack>
                }
              />
            ))}
          </Tabs>
        </Box>

        {/* Content */}
        {isAll ? (
          // ALL tab: show each language in sequence
          <Stack spacing={4}>
            {data.languages.map((lang, idx) => (
              <Box key={lang.id}>
                <LanguageSection language={lang} showLabel onPurchase={handlePurchase} purchasedCoursesByMajor={data?.purchasedCoursesByMajor} />
                {idx < data.languages.length - 1 && <Divider sx={{ my: 4, opacity: 0.5 }} />}
              </Box>
            ))}
          </Stack>
        ) : (
          // Single language tab
          <LanguageSection language={activeLanguage} showLabel={false} onPurchase={handlePurchase} purchasedCoursesByMajor={data?.purchasedCoursesByMajor} />
        )}

        <Divider sx={{ my: 5 }} />

        {/* Payment Methods */}
        <Box sx={{ mb: 5 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h6" fontWeight={800} gutterBottom>
              Payment Methods
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Secure and convenient ways to pay
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
              gap: 1.5,
            }}
          >
            {data.paymentMethods.map((method, i) => (
              <PaymentMethodCard key={i} method={method} onCopy={handleCopy} copied={copied} />
            ))}
          </Box>
        </Box>


        {/* Contact Info */}
        <Box sx={{ textAlign: 'center', bgcolor: alpha(theme.palette.primary.main, 0.03), borderRadius: 6, p: { xs: 3, md: 4 } }}>
          <Typography variant="subtitle1" fontWeight={800} gutterBottom>
            Need Help?
          </Typography>
          <Typography variant="caption" display="block" color="text.secondary" sx={{ mb: 3, fontSize: '0.8rem' }}>
            Contact our support team for any questions.
          </Typography>
          
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={1.5} 
            justifyContent="center"
            flexWrap="wrap"
            useFlexGap
          >
            {/* Phone Numbers */}
            {data.contact?.phone?.map((phone, idx) => {
              const cleanPhone = phone.replace(/\s/g, '');
              return (
                <Button
                  key={idx}
                  variant="outlined"
                  size="medium"
                  startIcon={<PhoneIcon fontSize="small" />}
                  onClick={() => handleCopy(cleanPhone)}
                  sx={{
                    py: 1,
                    px: 2.5,
                    borderRadius: '50px',
                    textTransform: 'none',
                    fontWeight: 700,
                    fontSize: '0.85rem',
                    bgcolor: 'background.paper',
                    borderColor: 'divider',
                    color: 'text.primary',
                    '&:hover': {
                      borderColor: 'primary.main',
                      bgcolor: 'background.paper',
                    }
                  }}
                >
                  {phone} 
                  {copied === cleanPhone && (
                    <Chip 
                      label="Copied" 
                      color="success" 
                      size="small" 
                      sx={{ ml: 1, height: 18, fontSize: '0.6rem' }} 
                    />
                  )}
                </Button>
              );
            })}

            {/* Facebook */}
            {data.contact?.facebook && (
              <Button
                variant="outlined"
                size="medium"
                startIcon={<FacebookIcon fontSize="small" />}
                href={data.contact.facebook}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  py: 1,
                  px: 2.5,
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  bgcolor: 'background.paper',
                  borderColor: '#1877F2',
                  color: '#1877F2',
                  '&:hover': {
                    bgcolor: '#1877F2',
                    color: 'white',
                  }
                }}
              >
                Facebook
              </Button>
            )}

            {/* Viber */}
            {data.contact?.viber && (
              <Button
                variant="outlined"
                size="medium"
                startIcon={<ChatIcon fontSize="small" />}
                href={data.contact.viber}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  py: 1,
                  px: 2.5,
                  borderRadius: '50px',
                  textTransform: 'none',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  bgcolor: 'background.paper',
                  borderColor: '#7360f2',
                  color: '#7360f2',
                  '&:hover': {
                    bgcolor: '#7360f2',
                    color: 'white',
                  }
                }}
              >
                Viber
              </Button>
            )}
          </Stack>
        </Box>

      </Container>
      
      {/* Payment Modal */}
      {selectedPlan && (
        <PaymentModal
          open={paymentModalOpen}
          onClose={() => setPaymentModalOpen(false)}
          plan={selectedPlan}
          courses={Array.isArray(selectedPlan.courses) && selectedPlan.courses.length > 0 ? selectedPlan.courses : [selectedPlan.id]}
          paymentMethods={data?.paymentMethods || []}
          onSuccess={handlePaymentSuccess}
        />
      )}

      {/* Success Snackbar */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default VipPlan;
